__turbopack_context__.v({
  "button-auto": "button-module-scss-module__NabTya__button-auto",
  "button-giant": "button-module-scss-module__NabTya__button-giant",
  "button-large": "button-module-scss-module__NabTya__button-large",
  "button-loading": "button-module-scss-module__NabTya__button-loading",
  "button-primary": "button-module-scss-module__NabTya__button-primary",
  "button-secondary": "button-module-scss-module__NabTya__button-secondary",
  "button-small": "button-module-scss-module__NabTya__button-small",
  "button-tertiary": "button-module-scss-module__NabTya__button-tertiary",
  "error-msg": "button-module-scss-module__NabTya__error-msg",
  "errorIcon": "button-module-scss-module__NabTya__errorIcon",
  "hint": "button-module-scss-module__NabTya__hint",
  "spinner": "button-module-scss-module__NabTya__spinner",
  "spinner-primary": "button-module-scss-module__NabTya__spinner-primary",
  "spinner-secondary": "button-module-scss-module__NabTya__spinner-secondary",
  "spinner-tertiary": "button-module-scss-module__NabTya__spinner-tertiary",
});
